
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center max-w-lg px-6">
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <p className="text-xl text-gray-600 mb-6">
            Oops! The page you requested ({location.pathname}) was not found.
          </p>
          <div className="space-y-4">
            <Button 
              onClick={() => navigate(-1)}
              variant="outline" 
              className="mr-4"
            >
              Go Back
            </Button>
            <Button 
              onClick={() => navigate("/")}
              className="bg-[#517FA4] hover:bg-[#3e6682]"
            >
              Return to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
